// extracted by mini-css-extract-plugin
export default {"desktopNav":"DesktopNavigation_desktopNav__AvuOi","navContainer":"DesktopNavigation_navContainer__CPNiF","navLink":"DesktopNavigation_navLink__4fjqd"};